// REISOR_DRIVER_TELEGRAM_PHONE_VERIFICATION_V1
// Non-secret registration resume state. Password/PIN and legal consent are never persisted here.

export const DRIVER_PHONE_VERIFICATION_STORAGE_KEY =
  "reisor_driver_phone_verify_v1";

export const DRIVER_REGISTRATION_DRAFT_STORAGE_KEY =
  "reisor_driver_register_draft_v1";

function safeParse(raw) {
  try {
    const value = JSON.parse(String(raw || ""));
    return value && typeof value === "object" ? value : null;
  } catch {
    return null;
  }
}

export function readDriverPhoneVerificationState() {
  try {
    return safeParse(localStorage.getItem(DRIVER_PHONE_VERIFICATION_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function saveDriverPhoneVerificationState(value) {
  try {
    if (!value) {
      localStorage.removeItem(DRIVER_PHONE_VERIFICATION_STORAGE_KEY);
      return;
    }
    localStorage.setItem(DRIVER_PHONE_VERIFICATION_STORAGE_KEY, JSON.stringify(value));
  } catch {}
}

export function readDriverRegistrationDraft() {
  try {
    return safeParse(localStorage.getItem(DRIVER_REGISTRATION_DRAFT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function saveDriverRegistrationDraft(value) {
  try {
    if (!value) {
      localStorage.removeItem(DRIVER_REGISTRATION_DRAFT_STORAGE_KEY);
      return;
    }
    localStorage.setItem(DRIVER_REGISTRATION_DRAFT_STORAGE_KEY, JSON.stringify(value));
  } catch {}
}

export function clearDriverRegistrationResumeState() {
  saveDriverPhoneVerificationState(null);
  saveDriverRegistrationDraft(null);
}
